/* Charlotte & Sage eigen winkelwagen. Gebruikt de standaard Shopify cart API,
   dus Shopify klantgebeurtenissen (TrackBee, Meta pixel) blijven gewoon werken. */
(function () {
  var root = document.getElementById('cs-cart');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var cfg = window.csCartConfig || {};
  var base = cfg.root || '/';
  var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.qty - b.qty; });
  var OWN = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CS-Cart': '1' };

  var el = function (s) { return root.querySelector(s); };
  var itemsEl = el('[data-cs-items]');
  var footerEl = el('[data-cs-footer]');
  var productCache = {};
  var cart = null;
  var refreshTimer = null;
  var origFetch = window.fetch.bind(window);

  function money(cents) {
    var cur = (cart && cart.currency) || cfg.currency || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function imgUrl(src, width) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  /* ---------- data ---------- */

  function fetchCart() {
    return origFetch(base + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = origFetch(base + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function post(path, body) {
    return origFetch(base + path, {
      method: 'POST',
      headers: OWN,
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  /* ---------- open en dicht ---------- */

  function open() {
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cs-cart-lock');
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cs-cart-lock');
  }

  function setBusy(on) {
    root.classList.toggle('is-busy', !!on);
  }

  function notifyTheme() {
    if (!cart) return;
    var ev = new Event('cart:update', { bubbles: true });
    ev.detail = {
      resource: cart,
      sourceId: 'cs-cart',
      data: { itemCount: cart.item_count, source: 'cs-cart' }
    };
    document.dispatchEvent(ev);
  }

  /* ---------- weergave ---------- */

  function renderProgress() {
    var box = el('[data-cs-progress]');
    if (!tiers.length || !cart || !cart.item_count) {
      box.hidden = true;
      return;
    }
    box.hidden = false;

    var count = cart.item_count;
    var n = tiers.length;
    var seg = 100 / n;
    var next = null;
    for (var i = 0; i < n; i++) {
      if (count < tiers[i].qty) { next = tiers[i]; break; }
    }

    var text = el('[data-cs-progress-text]');
    var words = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six'];
    var fill = function (tpl, need, p) {
      return esc(tpl)
        .replace(/\[number\]/g, words[need] || String(need))
        .replace(/\[discount\]/g, '<strong>' + p + '% off</strong>');
    };
    if (next) {
      var need = next.qty - count;
      text.innerHTML = fill(need === 1 ? (cfg.textOne || '') : (cfg.textMore || ''), need, next.pct);
    } else {
      text.innerHTML = fill(cfg.textDone || '', 0, tiers[n - 1].pct);
    }

    var pct = 0;
    if (count >= tiers[n - 1].qty) {
      pct = 100;
    } else if (count < tiers[0].qty) {
      pct = (count / tiers[0].qty) * seg;
    } else {
      for (var j = 0; j < n - 1; j++) {
        if (count >= tiers[j].qty && count < tiers[j + 1].qty) {
          pct = seg * (j + 1) + ((count - tiers[j].qty) / (tiers[j + 1].qty - tiers[j].qty)) * seg;
          break;
        }
      }
    }
    el('[data-cs-fill]').style.width = Math.min(100, pct) + '%';

  }

  function optionName(o) {
    return typeof o === 'string' ? o : (o && o.name) || '';
  }

  function lineHTML(item, product) {
    var variant = null;
    if (product && product.variants) {
      for (var v = 0; v < product.variants.length; v++) {
        if (product.variants[v].id === item.variant_id) { variant = product.variants[v]; break; }
      }
    }

    var unitCompare = variant && variant.compare_at_price ? variant.compare_at_price : 0;
    var strike = Math.max(unitCompare * item.quantity, item.original_line_price || 0);
    var finalPrice = item.final_line_price;
    var pct = strike > finalPrice ? Math.round((1 - finalPrice / strike) * 100) : 0;

    var variantText = item.product_has_only_default_variant ? '' : (item.variant_title || '');
    var urgency = cfg.urgency || '';

    var img = item.image
      ? '<img src="' + esc(imgUrl(item.image, 300)) + '" alt="' + esc(item.product_title) + '" loading="lazy">'
      : '';

    return '<div class="cs-line" data-key="' + esc(item.key) + '">' +
      '<a class="cs-line__img" href="' + esc(item.url) + '">' + img + '</a>' +
      '<div class="cs-line__info">' +
        '<a class="cs-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        '<div class="cs-line__prices">' +
          (pct ? '<span class="cs-line__compare">' + money(strike) + '</span>' : '') +
          '<span class="cs-line__price">' + money(finalPrice) + '</span>' +
          (pct ? '<span class="cs-line__save">' + esc(cfg.badge || 'SAVE') + ' ' + pct + '%</span>' : '') +
        '</div>' +
        (variantText ? '<p class="cs-line__variant">' + esc(variantText) + '</p>' : '') +
        '<div class="cs-line__actions">' +
          (urgency ? '<span class="cs-line__urgency"><span class="cs-line__pulse" aria-hidden="true"></span>' + esc(urgency) + '</span>' : '') +
          '<div class="cs-line__qty">' +
            '<button type="button" data-cs-step="-1" data-key="' + esc(item.key) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-cs-qty data-key="' + esc(item.key) + '" aria-label="Quantity">' +
            '<button type="button" data-cs-step="1" data-key="' + esc(item.key) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          (cfg.showRemove === false ? '' :
          '<button type="button" class="cs-line__remove" data-cs-remove data-key="' + esc(item.key) + '" aria-label="Remove item">' +
            '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>' +
          '</button>'
          ) +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function syncBubble() {
    var n = cart.item_count;
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (b) {
      b.textContent = n;
      b.classList.toggle('hidden', !n);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', !n);
      var sr = b.querySelector('.cart-bubble__text > .visually-hidden');
      if (sr) sr.textContent = 'Total items in cart: ' + n;
    });
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (b) {
      b.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
    });
  }

  function render() {
    if (!cart) return Promise.resolve();
    try { syncBubble(); } catch (e) {}
    renderProgress();

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cs-cart__empty"><p>Your cart is empty</p>' +
        '<a href="' + base + 'collections/all" data-cs-close>Continue shopping</a></div>';
      footerEl.hidden = true;
      return Promise.resolve();
    }

    footerEl.hidden = false;
    var discount = cart.total_discount || 0;
    var dRow = el('[data-cs-discount-row]');
    if (dRow) dRow.hidden = true;
    el('[data-cs-total]').textContent = money(cart.total_price);
    el('[data-cs-checkout-total]').textContent = money(cart.total_price);

    return Promise.all(cart.items.map(function (i) { return getProduct(i.handle); }))
      .then(function (products) {
        itemsEl.innerHTML = cart.items.map(function (item, idx) { return lineHTML(item, products[idx]); }).join('');
      });
  }

  function refresh(andOpen) {
    return fetchCart().then(render).then(function () {
      if (andOpen) open();
    });
  }

  function scheduleRefresh(andOpen) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () { refresh(andOpen); }, 60);
  }

  /* ---------- acties ---------- */

  function findItem(key) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === key) return cart.items[i];
    }
    return null;
  }

  function changeQty(key, qty) {
    setBusy(true);
    return post('cart/change.js', { id: key, quantity: Math.max(0, qty) })
      .then(function (c) { cart = c; return render(); })
      .then(notifyTheme)
      .catch(function (err) {
        if (err && err.description) alert(err.description);
        return refresh();
      })
      .then(function () { setBusy(false); });
  }

  function swapVariant(key) {
    var item = findItem(key);
    if (!item) return;
    var selects = itemsEl.querySelectorAll('select[data-key="' + CSS.escape(key) + '"]');
    getProduct(item.handle).then(function (product) {
      if (!product) return;
      var wanted = item.options_with_values.map(function (o) { return o.value; });
      selects.forEach(function (s) { wanted[parseInt(s.dataset.csOption, 10)] = s.value; });

      var match = null;
      product.variants.forEach(function (pv) {
        if (match) return;
        var ok = pv.options.every(function (val, i) { return val === wanted[i]; });
        if (ok) match = pv;
      });

      if (!match || match.id === item.variant_id) return render();
      if (!match.available) {
        alert('Sorry, this option is sold out.');
        return render();
      }

      setBusy(true);
      var addBody = { items: [{ id: match.id, quantity: item.quantity }] };
      if (item.properties && Object.keys(item.properties).length) addBody.items[0].properties = item.properties;

      return post('cart/add.js', addBody)
        .then(function () { return post('cart/change.js', { id: key, quantity: 0 }); })
        .then(function (c) { cart = c; return render(); })
        .then(notifyTheme)
        .catch(function (err) {
          if (err && err.description) alert(err.description);
          return refresh();
        })
        .then(function () { setBusy(false); });
    });
  }

  /* ---------- events ---------- */

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cs-close]')) {
      if (t.closest('a[data-cs-close]')) return close();
      e.preventDefault();
      return close();
    }
    var step = t.closest('[data-cs-step]');
    if (step) {
      var it = findItem(step.dataset.key);
      if (it) changeQty(it.key, it.quantity + parseInt(step.dataset.csStep, 10));
      return;
    }
    var rem = t.closest('[data-cs-remove]');
    if (rem) return changeQty(rem.dataset.key, 0);
    if (t.closest('[data-cs-checkout]')) {
      setBusy(true);
      window.location.href = base + 'checkout';
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('select[data-cs-option]')) return swapVariant(t.dataset.key);
    if (t.matches('input[data-cs-qty]')) {
      var q = parseInt(t.value, 10);
      if (isNaN(q)) q = 1;
      changeQty(t.dataset.key, q);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* Winkelwagen icoon in de header opent deze drawer in plaats van de cart pagina */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('a.action__cart, [data-cs-open], a[href="' + base + 'cart"], a[href="/cart"]');
    if (!trigger || root.contains(trigger)) return;
    e.preventDefault();
    e.stopPropagation();
    refresh(true);
  }, true);

  /* Elk product dat via de standaard Shopify cart API wordt toegevoegd opent de drawer */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && (init.headers['X-CS-Cart'] || (init.headers.get && init.headers.get('X-CS-Cart')));
    var p = origFetch(input, init);
    if (!own && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) scheduleRefresh(true); }).catch(function () {});
    } else if (!own && /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) scheduleRefresh(false); }).catch(function () {});
    }
    return p;
  };

  /* Thema events, bijvoorbeeld quick add */
  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if (d && (d.source === 'cs-cart' || d.didError)) return;
    scheduleRefresh(!!(d && (d.source === 'product-form-component' || d.variantId)));
  });

  window.CSCart = { open: function () { refresh(true); }, close: close, refresh: refresh };
})();
